export const frCommons = {
    'commons.or': 'Ou', //* TO TRAD

    //* LIST FILTER
    'modules.list.commons.filters.title': 'Filtrer :',
    'modules.list.filters.state.label': 'État',
    'modules.list.filters.audience': 'Audience : ',
    'modules.list.filters.audience.label': 'Audience',
    'modules.list.filters.shop.label': 'Centre',
    'modules.list.filters.audience.favoriteShops': 'Mes centres favoris',
    'commons.actions.apply': 'Appliquer',

    //* LIST FILTER STATE
    'modules.list.table.state': 'État :',
    'modules.list.table.state.draft': 'Brouillon',
    'modules.list.table.state.drafts': 'Brouillon',
    'modules.list.table.state.published': 'Publié',
    'modules.list.table.state.unpublished': 'Annulé',
    'modules.list.table.state.finished': 'Terminé',

    'modules.list.table.filter.state': 'État : {state}',
    'modules.list.table.state.Draft': 'Brouillon',
    'modules.list.table.state.Drafts': 'Brouillon',
    'modules.list.table.state.Published': 'Publié',
    'modules.list.table.state.Unpublished': 'Annulé',
    'modules.list.table.state.Finished': 'Terminé',

    //* LIST HEADER
    'modules.list.table.header.info': 'Informations',
    'modules.list.table.header.owner': 'Propriétaire',
    'modules.list.table.header.nbShops': 'Nombre de centres',
    'modules.list.table.header.endDate': "Date d'échéance",
    'modules.list.table.header.description': 'Description',
    'modules.list.table.header.type': 'Type',

    //* COMMONS LABELS
    'commons.label.createdDate': 'Crée le {date}',
    'commons.label.published.at': 'Publié le {date}',
    'commons.label.finished.at': 'Terminé (Terminé {date})',
    'commons.label.at': 'à',

    //* CONTENT EDITION
    'modules.content.edit.quit.confirmation':
        'Voulez-vous vraiment quitter ? Toutes vos modifications seront perdues.',

    //* CONTENT TABS
    'modules.content.tabs.info': 'Informations',
    'modules.content.tabs.details': 'Détails',
    'modules.content.tabs.questions': 'Questions',
    'modules.content.tabs.audience': 'Audience',
    'modules.content.tabs.notifications': 'Notifications',
    'modules.content.tabs.comments': 'Commentaires', //!TO TRAD
    'modules.content.tabs.results': 'Résultats',

    //* CONTENT TAB AUDIENCE
    'modules.content.audiences.treeTitle': 'Choix sectorisation',
    'modules.content.audiences.broadcastAudience': 'Tous les centres',
    'modules.content.audiences.def.section.title': 'Definition de l’Audience',

    'modules.content.audiences.def.collaborator.title':
        'Ce contenu doit être destiné à des collaborateurs spécifiques.',
    'modules.content.audiences.def.collaborator.subtitle':
        'Sélectionner les rôles des collaborateurs destinataires du contenu : ',

    'modules.content.audiences.def.title.shop':
        'Ce contenu doit être destiné à des collaborateurs spécifiques. Sélectionner les rôles des collaborateurs destinataires du contenu : ',

    'modules.content.audiences.def.audienceCount.shops.titleMany': 'Centres',
    'modules.content.audiences.def.audienceCount.shops.title': 'Centre',

    'modules.content.audiences.def.audienceCount.collaborators.titleMany': 'Collaborateurs',
    'modules.content.audiences.def.audienceCount.collaborators.title': 'Collaborateur',

    'modules.content.audiences.def.audienceCount.subtitleMany': 'Sélectionnés',
    'modules.content.audiences.def.audienceCount.subtitle': 'Sélectionné',

    //*
    'modules.content.comments.publishComment.sectionTitle': 'Publier un commentaire',
    'modules.content.comments.publishComment.contentTitle': 'Contenu',
    'modules.content.comments.list.sectionTitle': 'Liste des commentaires',
    'modules.content.comments.list.sectionTitle.enabledCountFormat': '{count} commentaire activé',
    'modules.content.comments.list.sectionTitle.enabledCountFormatMany':
        '{count} commentaires activés',
    'modules.content.comments.list.emptyLabel': "Il n'y a pas de commentaire pour le moment",

    'modules.content.comments.list.item.publishFormat': 'Posté le {date} à {time}',
    'modules.content.comments.list.item.publishFormatWithUserAndShop':
        'Commentaire de {user} de {shop}, posté le {date} à {time}',
    'modules.content.comments.list.item.publishFormatWithUser':
        'Commentaire de {user}, posté le {date} à {time}',
    'modules.content.comments.list.item.tooltip.disabledBy':
        'Supprimé par {user} le {date} à {time}',
    'modules.content.comments.list.item.publishDateFormat': 'dd/MM/yyyy',
    'modules.content.comments.list.item.publishTimeFormat': 'HH:mm',

    'modules.content.comments.remove.dialog.title': 'Désactiver ce commentaire',
    'modules.content.comments.remove.dialog.content':
        'Êtes-vous sûr de vouloir désactiver ce commentaire ?',

    //* DAYS
    'commons.day.Monday': 'Lundi',
    'commons.day.Tuesday': 'Mardi',
    'commons.day.Wednesday': 'Mercredi',
    'commons.day.Thursday': 'Jeudi',
    'commons.day.Friday': 'Vendredi',
    'commons.day.Saturday': 'Samedi',
    'commons.day.Sunday': 'Dimanche',

    //* WEEKS
    'commons.week.First': 'Première',
    'commons.week.Second': 'Deuxième',
    'commons.week.Third': 'Troisième',
    'commons.week.Fourth': 'Quatrième',
    'commons.week.Last': 'Dernière',

    //* QUESTIONAIRES FROM surveys
    'commons.questions.inputs.floatingLabelQuestionCode': 'Code question',
    'commons.questions.inputs.questionCode': 'Saisissez ici un code dédidé à cette question',
    'commons.questions.title': 'Titre',
    'commons.questions.titleHintText': 'Saisir ici un titre',
    'commons.questions.question': 'Question',
    'commons.questions.questionHintText': 'Saisir ici la question',
    'commons.questions.answersNeeded': 'Nb de réponses attendues',
    'commons.questions.description': 'Description',
    'commons.questions.descriptionHintText': 'Saisir ici une description',
    'commons.questions.uniqueChoice': 'QCU',
    'commons.questions.possibleAnswer': 'Réponse possible',
    'commons.questions.possibleAnswerHintText': 'Saisir ici la réponse',
    'commons.questions.externalReference': 'Ref. externe',
    'commons.questions.externalReferenceHintText': 'Saisir ici la référence',

    //* besoin de traductions
    'commons.questions.xAnswerPossibles':
        '{nbAnswers, plural, =0 {{nbAnswers} réponse possible} =1 {{nbAnswers} réponse possible} other {{nbAnswers} réponses possibles}}',

    'commons.questions.nextquestion': 'Question suivante',
    'commons.questions.addAnswer': 'Ajouter une réponse',
    'commons.questions.gotoend': 'Aller à la fin',
    'commons.questions.gotoquestion': 'Passer à la question',
    'commons.questions.gotoquestionFormat': 'Passer à la question {number}',
    'commons.questions.addQuestion': 'Ajouter une question',
    'commons.questions.type.label': 'Type de question',
    'commons.questions.type.undefined': 'Indéfini',
    'commons.questions.type.singlechoice': 'QCU',
    'commons.questions.type.multiplechoice': 'QCM',
    'commons.questions.type.text': 'Texte',

    //* RESULTS
    'commons.results.tableHeader.shop': 'Centre',
    'commons.results.tableHeader.shops': 'Centres',
    'commons.results.tableHeader.user': 'Collaborateur',
    'commons.results.tableHeader.state': 'État de réponse',

    'commons.results.emptyLabel': 'Aucun résultat pour le moment.',

    'commons.results.filters.state': 'Etat : {state}',

    'commons.results.item.state.Draft': 'Brouillon',
    'commons.results.item.state.Replied': 'Répondu',
    'commons.results.item.state.NotReplied': 'Non répondu',
    'commons.results.item.state.InProgress': 'En cours', //*to trad
    'commons.results.item.state.Yes': 'Oui',
    'commons.results.item.state.No': 'Non',

    'commons.results.reply.seeResult': 'Visualiser la réponse',

    'commons.results.response.label': 'Réponses:',
    'commons.results.response.format': '{total_replied_count} centres / {shop_count}',

    'commons.filter.answer.Answered': 'Participe',
    'commons.filter.answer.NotAnswered': 'Ne participe pas',
    'commons.filter.answer.format': 'Réponse : {answer}',
};
